<template src="./App.html"></template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
@import "./assets/styles/app.scss";
@import "./assets/styles/buttons.scss";
@import "./App.scss";
</style>

<script type="text/javascript">
import { isEmpty } from 'lodash';
import UserAvatar from '@/components/user/avatar/UserAvatar.vue';
import McLanguage from '@/components/language/McLanguage.vue';
import Multiselect from 'vue-multiselect';
import { mapState, mapActions, mapGetters } from 'vuex';
import { getCompanyByCompanyId, logout } from '@/api/index';
import { VERSION_CODE } from './utils/constants';

export default {
  name: 'App',
  components: {
    UserAvatar,
    McLanguage,
    Multiselect,
  },
  data() {
    return {
      tempBgIndex: 0,
      isSuperAdmin: false,
      versionCode: VERSION_CODE,
      companyName: '',
      isLoggingOut: false,
    };
  },
  methods: {
    giveChars(str) {
      return str.slice(0, 3);
    },
    signed() {
      if (!isEmpty(this.user)) {
        this.$store.state.logged = true;
        this.isSuperAdmin = this.user.user_type === 1;
        // if (process.env.VUE_APP_SENTRY_ENV === 'production') {
        //   this.$analytics.setUserId(this.user.user_id);
        //   this.$analytics.setUserProperties({
        //     userType: this.user.user_type,
        //   });
        // }
      }
    },

    async signOut() {
      try {
        this.isLoggingOut = true;
        await logout();
      } finally {
        await this.$store.dispatch('reset');
        this.$router.push('/login');
      }
    },

    async fetchCompanyName() {
      if (this.isLoggingOut) return;
      if (isEmpty(this.user) || !this.user.company_id) return;
      if (this.user.company?.company_name || this.user.company_name) return;

      try {
        const response = await getCompanyByCompanyId(this.user.company_id);
        if (response) {
          this.companyName = response.company_name || '';
        }
      } catch (error) {
        console.error('Error fetching company name:', error);
      }
    },

    toggleMenu() {
      if (this.$refs.mcSidebar.classList.contains('show')) {
        this.$refs.mcSidebar.classList.remove('show');
      } else {
        this.$refs.mcSidebar.classList.add('show');
      }
    },

    // Fetches permissions based on the user's role
    async fetchRoleActions() {
      // Safety check to ensure we have a valid user type before calling the API
      if (this.isLoggingOut || isEmpty(this.user) || !this.user.user_type) return;
      try {
        await this.apiGetRoleActionsByRole(this.user.user_type.type_id);
      } catch (error) {
        console.error('Error fetching role actions:', error);
      }
    },

    ...mapActions(['changeBackground']),
    ...mapActions('Users', ['apiGetRoleActionsByRole']),
  },
  beforeMount() {
    this.signed();
    setInterval(() => {
      this.changeBackground();
    }, process.env.VUE_APP_REFRESH_BG_MS);
  },
  mounted() {
    this.changeBackground();
    // Attempt to fetch if user is already present (e.g. page refresh)
    if (!isEmpty(this.user)) {
      this.fetchRoleActions();
    }
  },

  beforeUpdate() {
    if (!isEmpty(this.user)) {
      this.$store.state.logged = true;
    }
    this.signed();
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    displayCompanyName() {
      return this.user.company?.company_name || this.user.company_name || this.companyName || '';
    },
    ...mapGetters('Users', ['can']),
    ...mapState({}),
  },
  watch: {
    // FIX: Watch the 'user' object. When it changes (login), fetch permissions.
    user: {
      handler(newValue) {
        if (this.isLoggingOut || isEmpty(newValue)) return;
        if (!isEmpty(newValue)) {
          this.fetchRoleActions();
          this.signed();
          this.fetchCompanyName();
        }
      },
      deep: true,
      immediate: true
    }
  },
};
</script>